import { render, staticRenderFns } from "./Debug.vue?vue&type=template&id=12a2db8e&scoped=true"
import script from "./Debug.vue?vue&type=script&lang=ts"
export * from "./Debug.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a2db8e",
  null
  
)

export default component.exports